import React, { useState, useEffect } from 'react';
import { Row, Col, Label, Form, Card, CardBody } from 'reactstrap';
import { useForm } from 'react-hook-form';

const PostEventFeedbackFormV2 = ({ formSubmit, onPrevious, data, formStatus }) => {
    const {
        register,
        formState: { errors },
        watch,
        handleSubmit,
        getValues,
        setValue
    } = useForm({
        mode: "onBlur",
    });

    const fields = [
        "rate_venue_quality",
        "rate_seating_and_table_arrangements",
        "rate_timing_and_pacing",

        "quality_of_host",
        "length_of_ceremony",
        "production_value",
        "rate_speech_by_leader",

        "event_feel_prestigious",
        "entrants_inclusivity_balance",
        "sufficient_networking_opportunities",

        "number_of_people_spoken_to",
        "number_of_winner_interviews",
        "participant_general_feedback",

        "panel_duration",
        "panel_well_received",
        "rate_panelist_quality",
        "recommend_panel_next_year",
    ];

    const submit = (response) => {
        formSubmit(response);
    }

    const previous = (e) => {
        e.preventDefault();
        const data = getValues();
        onPrevious(data);
    }

    useEffect(() => {
        fields.map(field => setValue(field, data[field]));
    }, []);

    return (
        <Form onSubmit={handleSubmit(submit)}>

            <Card className="mb-4">
                <CardBody className="pb-3">
                    <Label className='my-1' style={{ fontWeight: '600' }}>
                        Logistics
                    </Label>
                    <br />

                    {/* rate_venue_quality */}
                    <Label className='my-2'>
                        Venue quality (rating) <span className="asterisk_red">*</span>
                    </Label>
                    <input
                        type="number"
                        max="5"
                        min="1"
                        {...register("rate_venue_quality", {
                            required: "This field is required",
                            min: {
                                value: 1,
                                message: "Minimum rating is 1"
                            },
                            max: {
                                value: 5,
                                message: "Maximum rating is 5"
                            }
                        })}
                        className={`form-control ${errors.rate_venue_quality ? "form-invalid mb-0" : "mb-0"}`}
                    />
                    {errors.rate_venue_quality ? <p role="alert" className="invalid-feedback mb-0">{errors.rate_venue_quality.message}</p> : null}

                    {/* rate_seating_and_table_arrangements */}
                    <div>
                        <Label className='mb-2 mt-4'>
                            Seating and table arrangements (rating) <span className="asterisk_red">*</span>
                        </Label>
                        <input
                            type="number"
                            max="5"
                            min="1"
                            {...register("rate_seating_and_table_arrangements", {
                                required: "This field is required",
                                min: {
                                    value: 1,
                                    message: "Minimum rating is 1"
                                },
                                max: {
                                    value: 5,
                                    message: "Maximum rating is 5"
                                }
                            })}
                            className={`form-control ${errors.rate_seating_and_table_arrangements ? "form-invalid mb-0" : "mb-0"}`}
                        />
                        {errors.rate_seating_and_table_arrangements ? <p role="alert" className="invalid-feedback mb-0">{errors.rate_seating_and_table_arrangements.message}</p> : null}
                    </div>

                    {/* rate_timing_and_pacing */}
                    <div>
                        <Label className='mb-2 mt-4'>
                            Timing and pacing of the evening (rating) <span className="asterisk_red">*</span>
                        </Label>
                        <input
                            type="number"
                            max="5"
                            min="1"
                            {...register("rate_timing_and_pacing", {
                                required: "This field is required",
                                min: {
                                    value: 1,
                                    message: "Minimum rating is 1"
                                },
                                max: {
                                    value: 5,
                                    message: "Maximum rating is 5"
                                }
                            })}
                            className={`form-control ${errors.rate_timing_and_pacing ? "form-invalid mb-0" : "mb-0"}`}
                        />
                        {errors.rate_timing_and_pacing ? <p role="alert" className="invalid-feedback mb-0">{errors.rate_timing_and_pacing.message}</p> : null}
                    </div>
                </CardBody>
            </Card>

            <Card className="mb-4">
                <CardBody className="pb-3">
                    <Label className='my-1' style={{ fontWeight: '600' }}>
                        Programme
                    </Label>
                    <br />

                    {/* quality_of_host */}
                    <Label className='my-2'>
                        Quality of host/MC (1-5) <span className="asterisk_red">*</span>
                    </Label>
                    <input
                        type="number"
                        min="1"
                        max="5"
                        {...register("quality_of_host", {
                            required: "This field is required",
                            min: {
                                value: 1,
                                message: "Minimum rating is 1"
                            },
                            max: {
                                value: 5,
                                message: "Maximum rating is 5"
                            }
                        })}
                        className={`form-control ${errors.quality_of_host ? "form-invalid mb-0" : "mb-0"}`}
                    />
                    {errors.quality_of_host ? <p role="alert" className="invalid-feedback mb-0">{errors.quality_of_host.message}</p> : null}

                    {/* length_of_ceremony */}
                    <div>
                        <Label className='mb-2 mt-4'>
                            Length of ceremony <span className="asterisk_red">*</span>
                        </Label>
                        <input
                            type="text"
                            {...register("length_of_ceremony", {
                                required: "This field is required",
                            })}
                            className={`form-control ${errors.length_of_ceremony ? "form-invalid mb-0" : "mb-0"}`}
                        />
                        {errors.length_of_ceremony ? <p role="alert" className="invalid-feedback mb-0">{errors.length_of_ceremony.message}</p> : null}
                    </div>

                    {/* production_value */}
                    <div>
                        <Label className='mb-2 mt-4'>
                            Production value (AV, staging, lighting) (1-5) <span className="asterisk_red">*</span>
                        </Label>
                        <input
                            type="number"
                            min="1"
                            max="5"
                            {...register("production_value", {
                                required: "This field is required",
                                min: {
                                    value: 1,
                                    message: "Minimum rating is 1"
                                },
                                max: {
                                    value: 5,
                                    message: "Maximum rating is 5"
                                }
                            })}
                            className={`form-control ${errors.production_value ? "form-invalid mb-0" : "mb-0"}`}
                        />
                        {errors.production_value ? <p role="alert" className="invalid-feedback mb-0">{errors.production_value.message}</p> : null}
                    </div>

                    {/* rate_speech_by_leader */}
                    <div>
                        <Label className='mb-2 mt-4'>
                            Speech by Leader / OC recipient (1-5) <span className="asterisk_red">*</span>
                        </Label>
                        <input
                            type="number"
                            max="5"
                            min="1"
                            {...register("rate_speech_by_leader", {
                                required: "This field is required",
                                min: {
                                    value: 1,
                                    message: "Minimum rating is 1"
                                },
                                max: {
                                    value: 5,
                                    message: "Maximum rating is 5"
                                }
                            })}
                            className={`form-control ${errors.rate_speech_by_leader ? "form-invalid mb-0" : "mb-0"}`}
                        />
                        {errors.rate_speech_by_leader ? <p role="alert" className="invalid-feedback mb-0">{errors.rate_speech_by_leader.message}</p> : null}
                    </div>
                </CardBody>
            </Card>

            <Card className="mb-4">
                <CardBody className="pb-3">
                    <Label className='my-1' style={{ fontWeight: '600' }}>
                        Atmosphere & Experience
                    </Label>
                    <br />

                    {/* event_feel_prestigious */}
                    <div>
                        <Label className='my-2'>
                            Did the event feel prestigious? <span className="asterisk_red">*</span>
                        </Label>
                        <p className='mb-2 d-flex align-items-center'>
                            <input
                                id="event_feel_prestigious_yes"
                                type='radio'
                                {...register("event_feel_prestigious", {
                                    required: 'Required',
                                })}
                                value="Yes"
                                className='mr-2 cursor-pointer'
                            />
                            <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="event_feel_prestigious_yes">Yes</Label>
                        </p>
                        <p className='mb-2 d-flex align-items-center'>
                            <input
                                id="event_feel_prestigious_no"
                                type='radio'
                                {...register("event_feel_prestigious", {
                                    required: 'Required',
                                })}
                                value="No"
                                className='mr-2 cursor-pointer'
                            />
                            <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="event_feel_prestigious_no">
                                No 
                            </Label>
                        </p>
                        {errors.event_feel_prestigious ? <p role="alert" className="invalid-feedback mb-0">{errors.event_feel_prestigious.message}</p> : null}
                    </div>

                    {/* entrants_inclusivity_balance */}
                    <div>
                        <Label className='mb-2 mt-4'>
                            Did it feel inclusive and well-balanced across entrants? <span className="asterisk_red">*</span>
                        </Label>
                        <p className='mb-2 d-flex align-items-center'>
                            <input
                                id="entrants_inclusivity_balance_yes"
                                type='radio'
                                {...register("entrants_inclusivity_balance", {
                                    required: 'Required',
                                })}
                                value="Yes"
                                className='mr-2 cursor-pointer'
                            />
                            <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="entrants_inclusivity_balance_yes">Yes</Label>
                        </p>
                        <p className='mb-2 d-flex align-items-center'>
                            <input
                                id="entrants_inclusivity_balance_no"
                                type='radio'
                                {...register("entrants_inclusivity_balance", {
                                    required: 'Required',
                                })}
                                value="No"
                                className='mr-2 cursor-pointer'
                            />
                            <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="entrants_inclusivity_balance_no">
                                No 
                            </Label>
                        </p>
                        {errors.entrants_inclusivity_balance ? <p role="alert" className="invalid-feedback mb-0">{errors.entrants_inclusivity_balance.message}</p> : null}
                    </div>

                    {/* sufficient_networking_opportunities */}
                    <div>
                        <Label className='mb-2 mt-4'>
                            Did you have sufficient networking opportunities? <span className="asterisk_red">*</span>
                        </Label>
                        <p className='mb-2 d-flex align-items-center'>
                            <input
                                id="sufficient_networking_opportunities_yes"
                                type='radio'
                                {...register("sufficient_networking_opportunities", {
                                    required: 'Required',
                                })}
                                value="Yes"
                                className='mr-2 cursor-pointer'
                            />
                            <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="sufficient_networking_opportunities_yes">Yes</Label>
                        </p>
                        <p className='mb-2 d-flex align-items-center'>
                            <input
                                id="sufficient_networking_opportunities_no"
                                type='radio'
                                {...register("sufficient_networking_opportunities", {
                                    required: 'Required',
                                })}
                                value="No"
                                className='mr-2 cursor-pointer'
                            />
                            <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="sufficient_networking_opportunities_no">
                                No 
                            </Label>
                        </p>
                        {errors.sufficient_networking_opportunities ? <p role="alert" className="invalid-feedback mb-0">{errors.sufficient_networking_opportunities.message}</p> : null}
                    </div>
                </CardBody>
            </Card>

            <Card className="mb-4">
                <CardBody className="pb-3">
                    <Label className='my-1' style={{ fontWeight: '600' }}>
                        Networking
                    </Label>
                    <br />

                    {/* number_of_people_spoken_to */}
                    <Label className='my-2'>
                        How many people did you speak to? <span className="asterisk_red">*</span>
                    </Label>
                    <input
                        type="number"
                        {...register("number_of_people_spoken_to", {
                            required: "This field is required"
                        })}
                        className={`form-control ${errors.number_of_people_spoken_to ? "form-invalid mb-0" : "mb-0"}`}
                    />
                    {errors.number_of_people_spoken_to ? <p role="alert" className="invalid-feedback mb-0">{errors.number_of_people_spoken_to.message}</p> : null}

                    {/* number_of_winner_interviews */}
                    <Label className='mb-2 mt-3'>
                        How many winners interviews did you do? <span className="asterisk_red">*</span>
                    </Label>
                    <input
                        type="number"
                        {...register("number_of_winner_interviews", {
                            required: "This field is required"
                        })}
                        className={`form-control ${errors.number_of_winner_interviews ? "form-invalid mb-0" : "mb-0"}`}
                    />
                    {errors.number_of_winner_interviews ? <p role="alert" className="invalid-feedback mb-0">{errors.number_of_winner_interviews.message}</p> : null}

                    {/* participant_general_feedback */}
                    <Label className='mb-2 mt-3'>
                        General feedback from everyone? <span className="asterisk_red">*</span>
                    </Label>
                    <textarea
                        {...register("participant_general_feedback", {
                            required: "This field is required"
                        })}
                        className={`form-control ${errors.participant_general_feedback ? "form-invalid mb-0" : "mb-0"}`}
                    />
                    {errors.participant_general_feedback ? <p role="alert" className="invalid-feedback mb-0">{errors.participant_general_feedback.message}</p> : null}
                </CardBody>
            </Card>

            <Card className="mb-4">
                <CardBody className="pb-3">
                    <Label className='my-1' style={{ fontWeight: '600' }}>
                        Panel (if there was one)
                    </Label>
                    <br />

                    {/* panel_duration */}
                    <Label className='my-2'>
                        How long did the panel run for? <span className="asterisk_red">*</span>
                    </Label>
                    <input
                        type="text"
                        {...register("panel_duration", {
                            required: "This field is required"
                        })}
                        className={`form-control ${errors.panel_duration ? "form-invalid mb-0" : "mb-0"}`}
                    />
                    {errors.panel_duration ? <p role="alert" className="invalid-feedback mb-0">{errors.panel_duration.message}</p> : null}

                    {/* panel_well_received */}
                    <Label className='mb-2 mt-3'>
                        Was the panel well received? <span className="asterisk_red">*</span>
                    </Label>
                    <p className='mb-2 d-flex align-items-center'>
                        <input
                            id="panel_well_received_yes"
                            type='radio'
                            {...register("panel_well_received", {
                                required: 'Required',
                            })}
                            value="Yes"
                            className='mr-2 cursor-pointer'
                        />
                        <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="panel_well_received_yes">Yes</Label>
                    </p>
                    <p className='mb-2 d-flex align-items-center'>
                        <input
                            id="panel_well_received_no"
                            type='radio'
                            {...register("panel_well_received", {
                                required: 'Required',
                            })}
                            value="No"
                            className='mr-2 cursor-pointer'
                        />
                        <Label className="font-weight-normal mb-0 cursor-pointer" htmlFor="panel_well_received_no">
                            No 
                        </Label>
                    </p>
                    {errors.panel_well_received ? <p role="alert" className="invalid-feedback mb-0">{errors.panel_well_received.message}</p> : null}

                    {/* rate_panelist_quality */}
                    <Label className='my-2'>
                        How would you rate the quality of the panellists? (1-5) <span className="asterisk_red">*</span>
                    </Label>
                    <input
                        type="number"
                        max="5"
                        min="1"
                        {...register("rate_panelist_quality", {
                            required: "This field is required",
                            min: {
                                value: 1,
                                message: "Minimum rating is 1"
                            },
                            max: {
                                value: 5,
                                message: "Maximum rating is 5"
                            }
                        })}
                        className={`form-control ${errors.rate_panelist_quality ? "form-invalid mb-0" : "mb-0"}`}
                    />
                    {errors.rate_panelist_quality ? <p role="alert" className="invalid-feedback mb-0">{errors.rate_panelist_quality.message}</p> : null}

                    {/* recommend_panel_next_year */}
                    <Label className='mb-2 mt-3'>
                        Would you suggest having the panel again next year? <span className="asterisk_red">*</span>
                    </Label>
                    <textarea
                        {...register("recommend_panel_next_year", {
                            required: "This field is required"
                        })}
                        className={`form-control ${errors.recommend_panel_next_year ? "form-invalid mb-0" : "mb-0"}`}
                    />
                    {errors.recommend_panel_next_year ? <p role="alert" className="invalid-feedback mb-0">{errors.recommend_panel_next_year.message}</p> : null}
                </CardBody>
            </Card>

            <Row>
                <Col md="6" className="text-left mt-3">
                    <button className="form-btn inline-block w-75 newbuttontheme text-white" onClick={previous}>PREVIOUS</button>
                </Col>
                <Col md="6" className="text-right mt-3">
                    <button className="form-btn inline-block w-50 newbuttontheme text-white submit-btn" type="submit" disabled={formStatus !== 'standby'}>{formStatus === 'standby' ? 'SAVE' : 'SAVING...'}</button>
                </Col>
            </Row>
        </Form>
    )
}

export default PostEventFeedbackFormV2;